import clsx from "clsx";

function Checkbox({
  label,
  className,
  checked,
  onChange,
}: {
  label: string;
  className?: string;
  checked?: boolean;
  onChange?: (checked: boolean) => void;
}) {
  return (
    <div className="flex items-center">
      <input
        id={label}
        type="checkbox"
        className="hidden" // Hides the checkbox
        defaultChecked={checked} // Default checked state
        // onChange={(e) => console.log(e.target.checked)} // Handle change
        onChange={(e) => onChange?.(e.target.checked)} // Handle change
      />
      <label
        htmlFor={label}
        className={clsx(
          "w-[21px] h-[21px] flex items-center justify-center bg-white border-[1px] border-gray-300 rounded cursor-pointer hover:bg-gray-100",
          checked ? "!bg-[#7CAA74]" : "", // Change bg color when checked
          className
        )}
      >
        {/* Icon when checked, controlled by sibling input:checked */}
        {checked && (
          <svg
            className="w-4 h-4 !bg-secondary" // Hidden by default
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="white"
          >
            <path
              fillRule="evenodd"
              d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
              clipRule="evenodd"
            />
          </svg>
        )}
      </label>
    </div>
  );
}

export default Checkbox;
